import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import {useSoftUIController} from "../../context";
import i18n from "../../config/i18n";

function isAuthenticated() {
    const token = localStorage.getItem('token');
    return token != null;
}

const PrivateRoute = ({ allowedRoles, component: Component, publicRoute }) => {

    const [controller, dispatch] = useSoftUIController();
    const { token, role } = controller;
    const currentLang = i18n.language;

    const isLoggedIn = isAuthenticated();

    if (!publicRoute) {

        if (!isLoggedIn) {
            return <Navigate to={`/${currentLang}/authentication/sign-in`} />;
        }

        if (allowedRoles && role && !allowedRoles.includes(role)) {
            return <Navigate to={`/${currentLang}/dashboard`} />;
        }
    }

    return <Component />;
};

PrivateRoute.propTypes = {
    allowedRoles: PropTypes.arrayOf(PropTypes.string),
    component: PropTypes.elementType.isRequired,
    publicRoute: PropTypes.bool,
};

export default PrivateRoute;
